export default {
  company: {
    default: 'Société | Sociétés',
    list: {
      page_title: 'Liste des sociétés'
    },
    edit: {
      page_title: 'Modification de la société :'
    },
    show: {
      page_title: 'Fiche société',
      tab_title: {
        user: 'Liste des utilisateurs',
        bookinginputfield: 'Références de réservation',
        companyfavorite: 'Lieux et hôtels favoris'
      }
    },
    managerValidation: {
      pre: 'Pré-validation',
      post: 'Post-validation',
      travelPolicyDontSuit: 'Post-validation politique de voyage non-conforme'
    },
    excludeOnlineNonFreeCancellation: 'Exclusion des offres avec annulation payante',
    excludeOnlineUnknownBreakfast: 'Exclusion des offres sans petit-déjeuner connu',
    requireHrsPayment: 'Paiement HRS requis',
    bookingFees: {
      title: 'Frais de réservation',
      global: 'globaux',
      perRoom: '@:_perRoom'
    },
    orderNumber: {
      title: 'Bon de commande requis',
      label: 'Libellé bon de commande'
    },
    logoImage: {
      title: 'Logo de la société',
      noLogoMessage: 'Aucun logo enregistré'
    },
    informations: {
      adresse: 'Adresse de la société',
      options: 'Options de la société',
      managers: 'Managers de la société',
      users: 'Utilisateurs de la société',
      title: 'Bon de commande requis',
      label: 'Libellé bon de commande'
    },
    help: {
      orderNumberPattern: '<ul><li> # correspond à un chiffre [0-9]</li><li> ? correspond à une lettre [a-z A-Z]</li><li> + correspond à la répétition du caractère précédent un nombre infini de fois</li><li>Exemple : ##??##+ donnera 11AA22 ou bien 12ZK1234</li></ul>'
    }
  }
}
